<template>
  <ModalProvider
    id="modalAsignarEstacion"
    ref="modal"
    size="md"
  >
    <template #title>
      Asignar Estación Carga/Descarga
    </template>

    <template #body>
      <div v-if="current" class="text-center">
        <div class="d-flex justify-content-center">
          <div class="input-group input-group-lg">
            <InputProvider
              v-model="searchbarra"
              placeholder="Barra de Estación"
              :value="searchbarra"
              @input="searchbarra = $event"
            />
            <div class="input-group-append">
              <ButtonProvider
                icon="fa-search"
                variant="success"
                class="px-3"
                :disabled="searchbarra.length < 8"
                @click="getBarraEstacion"
              />
            </div>
          </div>
        </div>
      </div>
    </template>

    <template #footer="{ hide }">
      <ButtonProvider
        label="Agregar más Tarde"
        variant="secondary"
        class="w-100 py-3 glow-on-hover"
        @click="closeCrearRecepcion(hide)"
      />
    </template>
  </ModalProvider>
</template>

<script>
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";
import { ModalProvider, InputProvider, ButtonProvider } from "@/components/atomic";

export default {
  name: "AsignarEstacionRecepcionModal",
  components: {
    ModalProvider,
    InputProvider,
    ButtonProvider,
  },
  inject: {
    refreshRecepcion: {
      from: "refreshRecepcion",
      default: () => {},
    },
  },
  props: {
    current: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isSelected: false,
      searchbarra: "",
    };
  },
  mounted() {
    $("#modalAsignarEstacion").on("hide.bs.modal", () => {
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
    });
  },
  watch: {
    searchbarra(newVal) {
      if (newVal.length > 17) {
        // Eliminar "01" si está al inicio
        if (newVal.startsWith("01")) {
          newVal = newVal.substring(2);
        }
        // Eliminar el último carácter
        newVal = newVal.slice(0, -1);
      }
      this.searchbarra = newVal;
    },
  },
  methods: {
    /**
     * Cierra el modal y reinicia el estado.
     * Acepta la función `hide` del slot de ModalProvider (si viene), o usa jQuery como fallback.
     */
    closeCrearRecepcion(hide) {
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
      this.selectedRampa = "";
      this.isSelected = false;
      this.searchbarra = "";
      if (typeof hide === "function") {
        hide();
      } else {
        $("#modalAsignarEstacion").modal("hide");
      }
    },

    /**
     * Método que obtiene la posicion de estacion según su barra.
     */
    getBarraEstacion() {
      let self = this;
      Notifications.alert.confirm(
        "Asignar Estación de Carga/Descarga",
        "¿Esta Seguro(a)?",
        "Si",
        function () {
          DynamicService.postAction(
            "wms",
            "recepcion",
            self.current.id,
            "asignar_estacion",
            {
              barra: self.searchbarra,
              tienda: self.current.tienda,
            }
          )
            .then(() => {
              Notifications.alert.success(
                "Asignar Estación",
                "Estación Asignada Correctamente"
              );
              $("#modalAsignarEstacion").modal("hide");
              self.refreshRecepcion();
              self.searchbarra = "";
            })
            .catch((error) => {
              self.searchbarra = "";
              console.log(error);
              self.errors = error.response.data;
              if (error.response.data.detail) {
                Notifications.alert.error(
                  "Asignar Estación",
                  error.response.data.detail
                );
              }
            });
        }
      );
    },
  },
};
</script>
